import { create } from 'zustand'

interface AssignmentModalState {
  isOpen: boolean
  selectedConversationIds: string[]
  setIsOpen: (isOpen: boolean) => void
  setSelectedConversationIds: (ids: string[]) => void
  toggleConversationSelection: (id: string) => void
  clearSelection: () => void
}

export const useAssignmentModalStore = create<AssignmentModalState>((set) => ({
  isOpen: false,
  selectedConversationIds: [],
  setIsOpen: (isOpen) => set({ isOpen }),
  setSelectedConversationIds: (ids) => set({ selectedConversationIds: ids }),
  toggleConversationSelection: (id) =>
    set((state) => ({
      selectedConversationIds: state.selectedConversationIds.includes(id)
        ? state.selectedConversationIds.filter((cid) => cid !== id)
        : [...state.selectedConversationIds, id],
    })),
  clearSelection: () => set({ selectedConversationIds: [] }),
}))
